export default "__VITE_ASSET__BVau6gRY__"